/**
 * MypageCancelContainer
 * --
 */
import React from 'react';
import MypageCancelPresenter from './MypageCancelPresenter';
import { useUserDataStack } from 'store';

const MypageCancelContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;
  /* ===== Store ===== */
  const { orderList } = useUserDataStack();

  /* ===== STATE ===== */
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 쇼핑몰 오더 데이터 정제
   * --
   */
  const OrderList = React.useMemo(() => {
    const newOrderList = orderList
      .filter(
        (order) =>
          order.payment_state === 'CANCELLED' ||
          order.payment_state === 'REFUNDED' ||
          order.payment_state === 'PARTIALLY_REFUNDED'
      )
      .map((order) => ({
        ...order,
        parcel_service: order.parcel_service.filter(
          (parcel) =>
            parcel.purchase_status === 'REFUNDED' ||
            parcel.purchase_status === 'RETURNED'
        ),
      }))
      .sort((a, b) => b.created_at - a.created_at);

    return newOrderList;
  }, [orderList]);

  /* ===== RENDER ===== */
  return (
    <>
      <MypageCancelPresenter
        order={OrderList}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        navigate={navigate}
        screenSize={screenSize}
      />
    </>
  );
};

export default MypageCancelContainer;
